import { call, put, select, takeLatest } from 'redux-saga/effects'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import {
  updatePageConfigurationData,
  updatePageConfigurationError,
  updatePageConfigurationInitialization,
  updatePageConfigurationIsLoading,
} from '@/store/PageConfiguration/PageConfigurationSlice'

import formV2InitializationMock from '@/containers/SubscriptionFormPageNew/mocks/initializeContact.json'
import zohoValidationMock from '@/containers/SubscriptionFormPageNew/mocks/zohoValidation.json'

export const pageConfigurationActions = {
  INITIALIZE: 'INITIALIZE',
}

export function* initializeSaga({ initUrl }) {
  if (import.meta.env.DEV) {
    let mockKeyExists = false
    const mockIds = Object.keys(zohoValidationMock)
    mockIds.forEach(key => {
      if (initUrl.includes(key)) {
        mockKeyExists = key
      }
    })
    if (mockKeyExists !== false) {
      yield put(updatePageConfigurationData(formV2InitializationMock[mockKeyExists]))
      yield put(updatePageConfigurationInitialization(true))
      return
    }
  }
  try {
    const { authTokenSession, lang } = yield select(selectAuthData)
    // test token expiration

    yield put(updatePageConfigurationIsLoading(true))
    yield put(updatePageConfigurationInitialization(false))
    let countryUrl = initUrl
    const language = lang ?? 'fr'
    if (initUrl.includes('?')) {
      countryUrl = `${initUrl}&lang=${language}`
    } else {
      countryUrl = `${initUrl}?lang=${language}`
    }

    const request = yield call(fetch, countryUrl, {
      method: 'get',
      mode: 'cors',
      headers: {
        Accept: 'Application/json',
        Authorization: 'Bearer ' + authTokenSession,
      },
    })

    const { status } = request
    const data = yield call([request, request.json])
    if (status === 200) {
      yield put(updatePageConfigurationData(data))
      yield put(updatePageConfigurationInitialization(true))
    } else {
      yield put(updatePageConfigurationError({ ...data, status }))
    }
  } catch (error) {
    yield put(updatePageConfigurationError(JSON.parse(error)))
  } finally {
    yield put(updatePageConfigurationIsLoading(false))
  }
}

export default function* pageConfigurationSagas() {
  yield takeLatest(pageConfigurationActions.INITIALIZE, initializeSaga)
}
